module.exports = __webpack_public_path__ + "static/media/8.deec81bf.jpg";